@if (item$ | async; as item) {
  @if (hasDropMenuItems(item)) {
    <div
      class="sh-compact-navigation__dropmenu"
      (mouseenter)="openSubMenu()"
      (mouseleave)="closeSubMenu()"
      (click)="openSubMenu()"
      (keyup.enter)="openSubMenu()"
      [attr.open]="item.isOpen ? 'true' : null"
      #detailsElement
      >
      <summary class="sh-compact-navigation__dropmenu__header" [ngClass]="{ '-sh-active': isActive$ | async }">
        @if (item.icon) {
          <svg sh-icon [name]="item.icon" class="sh-compact-navigation__link__icon" aria-hidden="true"></svg>
        }
        <span class="sh-compact-navigation__link__label" [title]="item.label">{{ item.label }}</span>
        @if (item.badge) {
          <sh-badge class="sh-compact-navigation__link__badge" [badge]="item.badge"></sh-badge>
        }
      </summary>
      <div class="sh-compact-navigation__dropmenu__list-wrapper" [ngClass]="{ '-sh-open-above': openDropmenuAbove }">
        <ul class="sh-compact-navigation__dropmenu__list">
          @for (dropmenuItem of item.dropmenuItems; track dropmenuItem) {
            <li
              class="sh-compact-navigation__dropmenu__list__item"
              [title]="dropmenuItem.label"
              routerLinkActive="-sh-active"
              (mouseenter)="onHover($event, dropmenuItem)"
              >
              <a [shNavigationLink]="dropmenuItem.navigationLink" class="sh-compact-navigation__dropmenu__link sh-icon-link" (click)="closeSubMenu()">
                <span>{{ dropmenuItem.label }}</span>
                @if (item.badge) {
                  <sh-badge class="sh-icon-link__icon" [badge]="item.badge"></sh-badge>
                }
              </a>
            </li>
          }
        </ul>
      </div>
    </div>
  } @else {
    <a [shNavigationLink]="item.navigationLink" [ngClass]="{ '-sh-active': isActive$ | async }" class="sh-compact-navigation__link">
      @if (item.icon) {
        <svg sh-icon [name]="item.icon" class="sh-compact-navigation__link__icon" aria-hidden="true"></svg>
      }
      <span class="sh-compact-navigation__link__label" [title]="item.label">{{ item.label }}</span>
      @if (item.badge) {
        <sh-badge class="sh-compact-navigation__link__badge" [badge]="item.badge"></sh-badge>
      }
    </a>
  }
}
